import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=6fcfa4aa&scoped=true&"
import script from "./Option.vue?vue&type=script&lang=js&"
export * from "./Option.vue?vue&type=script&lang=js&"
import style0 from "./Option.vue?vue&type=style&index=0&id=6fcfa4aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcfa4aa",
  null
  
)

export default component.exports